import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { HeaderContainer, Content } from 'carbon-components-react'

import FilterBar from '../FilterBar'
import Header from './components/Header'
import HeaderPanel from './components/HeaderPanel'
import HeaderActions from './components/HeaderActions'
import SidebarPanel from './components/SidebarPanel'
import withIsMobile from './withIsMobile'

import url from '../CHANGELOG.md'
import './index.scss'

class Shell extends Component {
  renderHeaderContainer = ({ isSideNavExpanded, onClickSideNavExpand }) => {
    const {
      i18nControls,
      searchPlaceholder,
      searchLabel,
      sidebarActions,
      productLogo,
      titleLink,
      themeSelection,
      sidebarTitleProp,
      userAvatarSrc,
      userName,
      userSurname,
      extraHeaderActionComponents,
      multiProjectControls,
      sidebarList = [],
      headerList = [],
      userActionAvatar = [],
      userInfo,
      showHeader = true,
      showSidebar = true,
      showSidebarSearch = true,
      versions,
      settingsLabels,
      settingPanelContent,
      location,
      getChangelogComponents,
      enableDragAndDrop,
      getMapModelByDragAndDrop
    } = this.props

    getChangelogComponents(url)

    return (
      <Fragment>
        {showHeader && (
          <Header
            isSideNavExpanded={isSideNavExpanded}
            onClickSideNavExpand={onClickSideNavExpand}
            headerList={headerList}
            logo={productLogo}
          >
            <HeaderActions
              i18nControls={i18nControls}
              multiProjectControls={multiProjectControls}
              themeSelection={themeSelection} // TODO:remove
              searchPlaceholder={searchPlaceholder}
              extraActionComponents={extraHeaderActionComponents}
            />
            <HeaderPanel
              settingPanelContent={settingPanelContent}
              userInfo={userInfo}
              avatarActions={userActionAvatar}
              userAvatarSrc={userAvatarSrc}
              userName={userName}
              userSurname={userSurname}
              versions={versions}
              settingsLabels={settingsLabels}
              location={location}
            />
          </Header>
        )}
        <SidebarPanel
          showSidebar={showSidebar}
          title={sidebarTitleProp}
          actions={sidebarActions}
          headerList={headerList}
          sidebarList={sidebarList}
          searchLabel={searchLabel}
          searchPlaceholder={searchPlaceholder}
          showSidebarSearch={showSidebarSearch}
          isSideNavExpanded={isSideNavExpanded}
          onClickSideNavExpand={onClickSideNavExpand}
          titleLink={titleLink}
          location={location}
          enableDragAndDrop={enableDragAndDrop}
          getMapModelByDragAndDrop={getMapModelByDragAndDrop}
        />
      </Fragment>
    )
  }

  render() {
    const {
      contentPadding,
      contentClassname,
      children,
      filterProps = {},
      expandSidebar = true,
      showHeader = true,
      showFilterbar = false,
      isMobile
    } = this.props

    return (
      <Fragment>
        <HeaderContainer
          isSideNavExpanded={expandSidebar}
          render={this.renderHeaderContainer}
        />
        <Content
          className={classNames('ublique-shell-content-container', {
            'no-header': !showHeader,
            'is-mobile': isMobile
          })}
        >
          <Content
            tagName='div'
            className={classNames(contentClassname, 'ublique-shell-content', {
              'no-padding': !contentPadding
            })}
          >
            {children}
          </Content>
          {showFilterbar && <FilterBar {...filterProps} />}
        </Content>
      </Fragment>
    )
  }
}

const Languages = PropTypes.objectOf(
  PropTypes.shape({
    full: PropTypes.string.isRequired,
    short: PropTypes.string
  })
)

Shell.propTypes = {
  sidebarList: PropTypes.array,
  headerList: PropTypes.array,
  userActionList: PropTypes.array,
  searchLabel: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  contentClassname: PropTypes.string,
  contentPadding: PropTypes.bool,
  expandSidebar: PropTypes.bool,
  showSidebarSearch: PropTypes.bool,
  /** Actions displayed beside the sidebar title, inside an overflow menu */
  sidebarActions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      onClick: PropTypes.func
    })
  ),
  i18nControls: PropTypes.shape({
    languages: Languages.isRequired,
    selectedLanguage: PropTypes.string.isRequired,
    onLanguageChange: PropTypes.func.isRequired
  }),
  multiProjectControls: PropTypes.shape({
    products: PropTypes.array.isRequired,
    selectedProduct: PropTypes.string,
    onProductChange: PropTypes.func
  })
}

export default withIsMobile(Shell)
